import {Component, Output, OnDestroy, OnInit, EventEmitter, ViewChild, Input} from "@angular/core";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Utils} from "@amlCore/utils";
import {AlertPanelComponent} from "@amlCore/components";
import {StringDateAdapterService, ValidatorService} from "@amlCore/services";
import {ClientPrintParamsModel} from "../../../models/dossier/clientPrintParamsModel";
import moment from "moment";
import {AlertModalComponent, ConfirmComponent} from "@amlCore/modals";
import {finalize} from "rxjs/operators";
import {DossierService} from "../../../services";
import {FileSaverService} from "ngx-filesaver";

/**
 * Компонент для ввода параметров и формирования печатной формы отчета
 */
@Component({
    selector: 'app-client-print-params',
    templateUrl: './clientPrintParams.component.html'
})

export class ClientPrintParamsComponent implements OnInit {
    @Input() params: ClientPrintParamsModel;
    @Output() onPrint: EventEmitter<String> = new EventEmitter();
    isUploaded: boolean = false;
    /**
     * Объект для отображения информации по сохранению
     */
    @ViewChild('alertObjSave', {static: true}) alertObjToSave: AlertPanelComponent;

    form: FormGroup;
    constructor(private formBuilder: FormBuilder,
                private modal: NgbActiveModal,
                private dossierService: DossierService,
                private modalService: NgbModal,
                private fSaver: FileSaverService
                ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            date: [moment(Date.now()).format( "DD.MM.YYYY"), Validators.required],
            format: ['ods', Validators.required],
        });
    }


    f(field: string) {
        return this.form.get(field);
    }

    /**
     * Закрываем модальное окно
     */
    goBack() {
        this.modal.dismiss(false);
    }

    /**
     * Сформировать печатную форму
     */
    onSave() {
        Object.assign(this.params, this.form.value);
        this.dossierService.checkClientsPrintForm(this.params).subscribe(res => {
            if(res.success) {
                this.downloadPrintForm();
            } else {
                if(res.result) {
                    const errNum = this.params.partType ? this.params.clientIds.length : this.params.dossierIds.length;
                    if (errNum > 0 && res.result.length < errNum) {
                        const modal = this.modalService.open(ConfirmComponent);
                        modal.componentInstance.text = res.errorMessage + ". Продолжить формирование?";
                        modal.componentInstance.isOutputText = false;
                        modal.result.then(
                          result => {
                              const toRemove = new Set(res.result);
                              if (this.params.partType) {
                                  this.params.clientIds = this.params.clientIds.filter(x => !toRemove.has(x));
                              } else {
                                  this.params.dossierIds = this.params.dossierIds.filter(x => !toRemove.has(x));
                              }
                              this.downloadPrintForm();
                          },
                          cancel => {
                              this.modal.dismiss(true);
                          });
                        return;
                    }
                }
                const modal = this.modalService.open(AlertModalComponent);
                modal.componentInstance.text = res.errorMessage;
                modal.componentInstance.isOutputText = false;
                this.modal.dismiss(true);
            }

        });

    }

    downloadPrintForm() {
        this.isUploaded = null;
        this.dossierService.downloadPrintForm(this.params).pipe(finalize(() => this.isUploaded = true)).subscribe(data => {
            if (data.type === 4) {
                this.fSaver.save(data.body, Utils.getFileNameFromContentDisposition(data));
                this.onPrint.emit('Анкета распечатана');
                this.modal.dismiss(true);
            }
        });
    }

}
